'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import { useModalContext } from '~/context/flp/ModalContext/ModalContext';
import useToggleAccountModal from '~/hooks/common/accountModal/useToggleAccountModal';
import useRefreshTerms from '~/hooks/flp/services/useRefreshTerms';
import useSetDataDogContext from '~/hooks/flp/telemetry/useSetDataDogContext';
import useTermsUpdated from '~/hooks/flp/useTermsUpdated';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/flp';

type OwnProps = {
  isLoggedIn: boolean;
};

export default function FinancingData({ isLoggedIn }: OwnProps) {
  const { creditStatus, isInitialized } = useFinancingContext();
  const { isAccountModalOpen, setAccountModalOpen } = useModalContext();
  const refreshTerms = useRefreshTerms();

  // Initialize financing data if user is logged in
  useEffectOnce(
    () => {
      refreshTerms();
    },
    [refreshTerms],
    isLoggedIn
  );

  useNativeMessageListener();
  useNativeMessageDispatcher(
    !isLoggedIn || isInitialized,
    !!creditStatus?.hasValidSoftPull
  );
  useTermsUpdated(isLoggedIn);
  useToggleAccountModal({ isAccountModalOpen, setAccountModalOpen });
  useSetDataDogContext();

  return null;
}
